// app/frontend/pages/Errors/NotFound.tsx
import React from 'react';
import { Box, Title, Text, Group, Button, Image, Stack } from '@mantine/core';
import { Link } from '@inertiajs/react';
import logoUrl from '/assets/NEW WCWD LOGO WHITE.svg';

export default function NotFound() {
  return (
    <Box
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'flex-start', // align to top
        justifyContent: 'center',
        paddingTop: '6rem',
        textAlign: 'center',
        paddingLeft: '1rem',
        paddingRight: '1rem',
      }}
    >
      <Stack gap="md" align="center">
        <Image src={logoUrl} alt="Logo" w={400} mb="xl" pl="xl" />

        <Title order={1} size="h1" fw={700} className="rubik-header">
          404 – Page Not Found
        </Title>

        <Text size="lg" className="poppins" fw={500} color="#f2f2f2">
          Oops! The page you’re looking for doesn’t exist or has been moved.
        </Text>

        <Group gap="md" justify="center">
          <Button component={Link} href="/" size="md" color="#EA580C" variant="filled">
            Return Home
          </Button>
          <Button component={Link} href="/events" size="md" color="#EA580C" variant="outline">
            Browse Events
          </Button>
        </Group>
      </Stack>
    </Box>
  );
}
